<template>
  <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9.67L8.59 7.09L10 8.5L5 13.5L0 8.5L1.41 7.09L4 9.67L4 0L6 0L6 9.67Z" fill="#151515" />
  </svg>
</template>
